import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class DeductibleMustBeLessThanOOP extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        return Number(candidate.benefits.deductible) <= Number(candidate.benefits.outOfPocket);
    }

}